<template>
    <div class="c-hero c-home c-home--has-grid">
       <div class="c-hero-bg">
            <video autoplay=""  loop="" muted="" :poster="video_placeholder"><source :src="video_bg" type="video/mp4"></video>
        </div>
        <GridBackground />
        <div class="c-hero__video-container">
            <div class="c-hero__video-inner">
                <div class="c-hero__video">
                     <div class="c-hero__video-media">
                         <img :src="video_thumb" alt="video"/>
                         <button class="c-hero__video-play" @click="open_video_modal" aria-label="play video"></button>
                     </div>
                    <div class="c-hero__video-button">
                <HoldButton :text="hold_text" v-on:max_hit="open_video_modal"/>
                </div>
                </div>
            </div>
        </div>
        <AnimatedText :speed="animation_speed" :text="animation_text"/>
        <GlitchText :text="glitch_text"/>
        <ModalVideo v-model="open_modal" :video="active_video" v-on:input="close_video_modal"/> 
    </div>
</template>
<script>

import AnimatedText from '@/components/AnimatedText.vue'
import GlitchText from '@/components/GlitchText.vue'
import HoldButton from '@/components/HoldButton.vue'
import ModalVideo from '@/components/ModalVideo'
import GridBackground from '@/components/GridBackground'
import jQuery from 'jquery'

let $ = jQuery;

export default {
    name: 'HomeHero',    
    components: {
        AnimatedText,
        GlitchText,
        HoldButton,
        ModalVideo,
        GridBackground
    },

    data: () => ({
        animation_speed: '30s',
        animation_text: 'National Champs ',
        glitch_text: 'ONE TEAM. ONE HEARTBEAT.',
        current_section: 0,
        previous_window_width: window.innerWidth,
        section_positions: [],
        hold_text: 'Hold for Video',
        open_modal: false,
        $video: false,
        video_bg: require('../assets/video-bg-1.mp4'),
        video_placeholder: require('../assets/video-bg.jpg'),
        video_thumb: require('../assets/highlights.jpg'),
        highlight_video: 'https://lsusports.net/showcase/embed.aspx?Archive=2805&amp;autoplay=false',
        active_video:'',
    }),

    methods: {
        open_video_modal(){
            this.active_video = this.highlight_video;
            this.open_modal = true;
            this.$video.pause();
        },
        close_video_modal() {
            this.open_modal = false;
            this.active_video = '';
            this.$video.play();
        },
    },

    created() {
        
    },
    mounted(){
        this.$video = $('.c-hero-bg video').get(0);
    }

}
</script>

<style lang="scss" scoped>
    @import "../styles/imports";
    .c-hero{
        position:relative;
        
        &::after{
            position:absolute;
            top:50%;
            height:50%;
            background:url('../assets/fleur_pattern.png') top left repeat-y;
            left:0;
            width:20%;            
            content:'';
            pointer-events:none;
            
        }
    }
    .c-hero-bg{
        position: absolute;
        top: 0;
        left: 0;
        width:100%;
        height: 100%;
        filter:grayscale(1);
        video{
            background:#222;
            height:100%;
            left:0;
            -o-object-fit: cover;
            object-fit: cover;
            position: absolute;
            top:0;
            width:100%;
        }
        &::after{
            position: absolute;
            top: 0;
            left: 0;
            width:100%;
            height: 100%;
            content:'';
            background: rgba(0,0,0,0.75);
        }
    }

    .c-hero__video-container{
        position: relative;
        width:100%;
        z-index: 10;
    }
    .c-hero__video-inner{
        padding:0 24px;
        margin: 0 auto;
        position: relative;
    }
    .c-hero__video{
        
    }
    .c-hero__video-media{
        width:100%;
        padding-bottom:56.25%;
        overflow: hidden;
        position: relative;
        background:#000;
        border:solid 1px $white;
        img{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            opacity:0.4;
        }
    }
    .c-hero__video-button{
        padding-top: 48px;
        position:relative;
        text-align:left;
        &::before{
            position: absolute;
            top: 0;
            left: 59px;
            width:1px;
            height: 48px;
            content:'';
            background:$white;
        }
    }
    .c-hero__video-play{
        @include appearance;
        position: absolute;
        top: 50%;
        left: 50%;
        width:60px;
        height:60px;
        @include transform(translate(-50%,-50%));
        &:hover{
            cursor: pointer;
            &::after{
                border-left-color:$gold;
            }
        }
        &::after{
            position: absolute;
            top: 50%;
            left: 50%;
            @include transform(translate(-50%,-50%));
            border-top: 35px solid transparent;
            content:'';
            border-left: 50px solid $white;
            border-bottom: 35px solid transparent;
            transition:0.2s;
        }
    }

    @media all and (min-width:$small-breakpoint){
        .c-hero{
            &::after{
                top:calc((100vw * 0.6 * 0.33333 * 0.5625 * 3));
                height:calc(100vh - (100vw * 0.6 * 0.33333 * 0.5625 * 3));
                background:url('../assets/fleur_pattern.png') top right repeat;
            }

        }
        .c-hero__video-container{
            padding-top:calc(100vw * 0.6 * 0.33333 * 0.5625 * 0.8);
        }
        .c-hero__video-inner{
            padding:0;
             width:calc(60% + 48px);
        }
        .c-hero__video{
            width:calc(100vw * 0.2 + 48px);
        }
        .c-hero__video-button{
            padding-top:156px;
            text-align:center;
            &::before{
                height:156px;
                left:50%;
            }
        }

    }
</style>